<template>
    <BreezeAuthenticatedLayout>
        <div class="max-w-7xl mx-auto py-10 px-3 sm:px-6 lg:px-8">
            <updateProfile :user="user" />
            <updatePassword />
        </div>
    </BreezeAuthenticatedLayout>
</template>
<script>
import updateProfile from "./UpdateProfile";
import updatePassword from "./UpdatePassword";
import BreezeAuthenticatedLayout from "@/Layouts/Authenticated";
export default {
    props: {
        user: Object,
        errors: Object,
    },
    components: {
        updateProfile,
        updatePassword,
        BreezeAuthenticatedLayout,
    },
};
</script>
